import Vue from "vue";

import YOURentLocator from "@Scripts/Components/YOURent/Locator.vue";
import YOURentDealerPointDetail from "@Scripts/Components/YOURent/DealerPointDetail.vue";

import RentalMarineRequest from "@Scripts/Components/RentalMarine/RentalMarineRequest.vue";

import YESMarineRegistration from "@Scripts/Components/YESMarine/YESMarineRegistration.vue";

import AccountLogin from "@Scripts/Components/Account/AccountLogin.vue";
import AccountLogout from "@Scripts/Components/Account/AccountLogout.vue";
import AccountPasswordRemind from "@Scripts/Components/Account/AccountPasswordRemind.vue";
import AccountPasswordReset from "@Scripts/Components/Account/AccountPasswordReset.vue";

import JobOfferDetail from "@Scripts/Components/WorkWithUs/JobOfferDetail.vue";
import JobProfileSubmit from "@Scripts/Components/WorkWithUs/JobProfileSubmit.vue";
import WorkWithUsLocator from "@Scripts/Components/WorkWithUs/WorkWithUsLocator.vue";

import NewsletterUnsubscribe from "@Scripts/Components/Newsletter/NewsletterUnsubscribe.vue";

import CookieToast from "@Scripts/Components/CookieToast/CookieToast.vue";
import PrivacyPolicy from "@Scripts/Components/PrivacyPolicy/PrivacyPolicy.vue";

import MaintenancePackageEstimateRequest from "@Scripts/Components/MaintenancePackage/MaintenancePackageEstimateRequest.vue";

import EventToolTestRideRegistration from "@Scripts/Components/EventToolEvent/EventToolTestRideRegistration.vue";
import EventToolTestRideRegistrationDialog from "@Scripts/Components/EventToolEvent/EventToolTestRideRegistrationDialog.vue";
import EventToolTestRideBooking from "@Scripts/Components/EventToolTestRideBooking/EventToolTestRideBooking.vue";

import LandingPageContact from "@Scripts/Components/LandingPage/LandingPageContact.vue";

// Directives
import ExpMenu from "@Scripts/Directives/ExpMenu/ExpMenu";
import CloseJobProfileForm from "@Scripts/Directives/CloseJobProfileForm/CloseJobProfileForm";

export default class AppConfig {
    public static AddComponents() {
        Vue.component("app-yourentlocator", YOURentLocator);
        Vue.component("app-yourentdealerpointdetail", YOURentDealerPointDetail);

        Vue.component("app-rentalmarinerequest", RentalMarineRequest);

        Vue.component("app-yesmarineregistration", YESMarineRegistration);

        Vue.component("app-accountlogin", AccountLogin);
        Vue.component("app-accountlogout", AccountLogout);
        Vue.component("app-accountpasswordremind", AccountPasswordRemind);
        Vue.component("app-accountpasswordreset", AccountPasswordReset);

        Vue.component("app-jobofferdetail", JobOfferDetail);
        Vue.component("app-jobprofilesubmit", JobProfileSubmit);
        Vue.component("app-workwithuslocator", WorkWithUsLocator);

        Vue.component("app-newsletterunsubscribe", NewsletterUnsubscribe);

        Vue.component("app-cookietoast", CookieToast);
        Vue.component("app-privacypolicy", PrivacyPolicy);

        Vue.component("app-maintenancepackageestimaterequest", MaintenancePackageEstimateRequest);

        Vue.component("app-eventtooltestrideregistration", EventToolTestRideRegistration);
        Vue.component("app-eventtooltestrideregistrationdialog", EventToolTestRideRegistrationDialog);
        Vue.component("app-eventtooltestridebooking", EventToolTestRideBooking);

        Vue.component("app-landingpagecontact", LandingPageContact);
    }

    public static AddDirectives() {
        Vue.directive("exp-menu", ExpMenu);
        Vue.directive("close-jobprofileform", CloseJobProfileForm);
    }
}